import React from "react";
import ModuleSwitcher from "./ModuleSwitcher";

export default function ContactsModuleSwitcher({ current }) {
  return (
    <ModuleSwitcher
      current={current}
      primaryAccess="bre.contacts"
      secondaryAccess="prospecting.contacts"
      primaryValue="bre"
      secondaryValue="prospecting"
      primaryLabel="BR&E Contacts"
      secondaryLabel="Prospect Contacts"
      primaryRoute="/bre-contacts"
      secondaryRoute="/prospecting-contacts"
      singleLabel={({ canSeeSecondary }) =>
        canSeeSecondary ? "Prospect Contacts" : "BR&E Contacts"
      }
    />
  );
}
